// Informs user of potential network connectivity issues
// uses Notifications banner

// Dependencies
import { useEffect, useCallback, useState } from "react";

// Hooks
import { useNotifications } from "./useNotifications";

const Notification = {
  Network: "Network",
} as const;

interface NetworkStatus {
  status: boolean;
}

// Check network status
function useNetwork(): NetworkStatus {
  const [status, setStatus] = useState<boolean>(navigator.onLine);

  const { addNotification, removeNotification } = useNotifications();

  // Online event handler
  const handleOnline = useCallback(() => {
    setStatus(true);
  }, [setStatus]);

  // Offline event handler
  const handleOffline = useCallback(() => {
    setStatus(false);
  }, [setStatus]);

  // Register online/offline event handler
  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [handleOnline, handleOffline]);

  useEffect(() => {
    if (!status) {
      addNotification({
        type: Notification.Network,
        message:
          "Network issues detected. Please check your network connection.",
      });
    } else {
      removeNotification({
        type: Notification.Network,
      });
    }
  }, [status, addNotification, removeNotification]);

  return { status };
}

export { useNetwork };
